export default "__VITE_ASSET__Dq0sUtqZ__"